import { graphql } from 'gatsby';

import { Grid2 as Grid, styled } from '@mui/material';

import { DownloadButton, ResponsiveGrid } from '@mewa/ui';

import {
  ComponentProps,
  ConfigType,
  ContentSectionItem,
  PossibleContentSections,
} from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export type DownloadData = {
  downloadDescription?: string;
  label: string;
  downloadItem: { fields: { assetUrl: string } };
  strapi_component: typeof componentName;
};

export type DownloadPreviewData = DownloadData;

export const query = graphql`
  fragment DownloadFragment on STRAPI__COMPONENT_SHARED_DOWNLOAD {
    downloadDescription: description
    label
    downloadItem {
      fields {
        assetUrl
      }
    }
    strapi_component
  }
`;

const componentName = 'shared.download';

const isComponent = (
  section: PossibleContentSections,
): section is ContentSectionItem<DownloadData> =>
  section.strapi_component === componentName;

const Component = (props: ComponentProps<DownloadData>) => (
  <Container>
    <DownloadButton
      label={props.label}
      url={props.downloadItem.fields.assetUrl}
      description={props.downloadDescription}
    ></DownloadButton>
  </Container>
);

const Container = styled('div')(({ theme }) => ({
  width: '80%',

  [theme.breakpoints.up('sm')]: {
    width: '50%',
  },

  [theme.breakpoints.up('md')]: {
    width: '60%',
  },

  [theme.breakpoints.up('lg')]: {
    width: '50%',
  },
}));

export const GridWrapperDownload = (props: ComponentProps<DownloadData>) => {
  return (
    <ResponsiveGrid>
      <Grid size={12}>
        <Component {...props} />
      </Grid>
    </ResponsiveGrid>
  );
};

export const config: ConfigType<DownloadData> = {
  Component,
  isComponent,
  componentName,
};
export const campaignConfig: ConfigType<DownloadData> = {
  Component: GridWrapperDownload,
  isComponent,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {
    downloadItem: '*',
  },
  mapProperties: (data) =>
    data.strapi_component === componentName ? data : null,
};
